"use strict";

var _ = require("lodash");

module.exports = {
    //Formats the string with the provided arguments substituted for placeholders ({n}).
    formatString: function (str) {
        var argsArray = Array.prototype.slice.call(arguments, 1);
        var placeholders = str.match(/{(.*?)}/g);
        for (var placeholder of placeholders) {
            var index = placeholder.substring(1, placeholder.length - 1);
            if (argsArray[index]) {
                str = str.replace(placeholder, argsArray[index]);
            }
        }
        return str;
    },

    /**
     * @function
     * @description Extracts all parameters from a given query string into an object
     * @param {String} qs The query string from which the parameters will be extracted
     */
    getQueryStringParams: function (url) {
        var qs;

        if (!_.isString(url)) { return; }
        var a = document.createElement("a");
        a.href = url;

        if (a.search) {
            qs = a.search.substr(1); // remove the leading ?
        }

        if (!qs || qs.length === 0) { return {}; }

        var params = {},
            unescapedQS = decodeURIComponent(qs);
        // Use the String::replace method to iterate over each
        // name-value pair in the string.
        unescapedQS.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"),
            function ($0, $1, $2, $3) {
                params[$1] = $3;
            }
        );
        return params;
    },

    /**
     * @function
     * @description appends the parameter with the given name and value to the given url and returns the changed url
     * @param {String} url the url to which the parameter will be added
     * @param {String} name the name of the parameter
     * @param {String} value the value of the parameter
     */
    appendParamToURL: function (url, name, value) {
        // quit if the param already exists
        if (url.indexOf(name + "=") !== -1) {
            return url;
        }

        var separator = url.indexOf("?") !== -1 ? "&" : "?";

        return url + separator + name + "=" + encodeURIComponent(value);
    },

    /**
     * @function
     * @description appends the parameters to the given url and returns the changed url
     * @param {String} url the url to which the parameters will be added
     * @param {Object} params
     */
    appendParamsToUrl: function (url, params) {
        var _url = url;

        _.each(params, function (value, name) {
            _url = this.appendParamToURL(_url, name, value);
        }.bind(this));

        return _url;
    },

    /**
     * getCookie
     *
     * Get the value of a cookie
     * @param {String} key
     * @returns
     */
    getCookie: function (key) {
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var tokens = cookies[i].split("=");
            var cookieKey = tokens[0].trim();

            if (cookieKey === key) {
                return tokens[1];
            }
        }

        return "";
    }
};
